const tabs = [
    {
      label: "Manage Members",
      value: "users",
    },
    {
      label: "Licenses and Team",
      value: "licenses",
    },
    {
      label: "Regions",
      value: "regions",
    },
    {
        label: "Territories",
        value: "territories",
    },
    {
        label: "Zones",
        value: "zones",
    }
  ];
  
  export function Tabs({ value, onChange }) {
    return (
      <div>
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            className={`report-tab-button relative text-base p-2 md:p-2.5 ${
              value === tab.value
                ? "text-primary selected-report-tab-button font-semibold"
                : "text-text-primary hover:text-text-primary/70 font-normal"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  }
  